import { handleErrorApi } from '@/shared/lib';
import { createClient } from '@/shared/api';
import type { RmaLimitConfigQuery, RmaLimitConfigQueryVariables } from '@/shared/api';
import RMA_LIMIT_CONFIG_QUERY from '../queries/rmaLimitConfig';

/**
 * Loads the RMA limit configuration, such as the maximum number of devices per ticket. Runs the rmaLimitConfig query and throws the first GraphQL error when no configuration came back.
 *
 * @returns A promise resolving to the limit configuration, or null when none is set.
 */
const fetchRmaLimitConfig = async (): Promise<RmaLimitConfigQuery['rmaLimitConfig']> => {
  const client = createClient();
  const result = await client.query<RmaLimitConfigQuery, RmaLimitConfigQueryVariables>({
    query: RMA_LIMIT_CONFIG_QUERY,
  });
  return handleErrorApi(result, 'rmaLimitConfig');
};

export default fetchRmaLimitConfig;
